import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, } from "@angular/core";
export interface MenuItem {
  tabName: string;
  itemText: string;
  itemIconUri?: string;
  itemIconUriActive?: string;
  itemIconUriInactive?: string;
  itemIconClass?: string;
  route?: string;
}
@Component({
  selector: "app-footer-navigation-bar",
  imports: [CommonModule],
  templateUrl: "./footer-navigation-bar.component.html",
  styleUrls: ["./footer-navigation-bar.component.scss"]
})
export class FooterNavigationBarComponent {

  @Input({ required: true }) menuItems: MenuItem[] = [];
  @Input({ required: true }) defaultItem: string = "";
  @Output() tabChanged = new EventEmitter<MenuItem>();

  navigate(event: Event, item: MenuItem) {
    event.preventDefault();
    if (item.tabName !== this.defaultItem) {
      this.tabChanged.emit(item);
    }
  }
}

